import React, { useState, useCallback } from "react"
import { CSSTransition } from "react-transition-group"

interface TooltipProps {
  show: boolean
  children?: React.ReactNode
}

export const Tooltip: React.FC<TooltipProps> = ({ show, children }) => {
  return (
    <CSSTransition classNames="animation" in={show} unmountOnExit timeout={100}>
      <div className="tooltip z-20 after:z-10">
        <span className="tooltip-text paragraph-2xs bold light mb-0 block">{children}</span>
      </div>
    </CSSTransition>
  )
}

let hideTimer: number

export const useTooltip = (text: string, timeout = 3500): [() => void, () => void, JSX.Element] => {
  const [show, setShow] = useState(false)

  const showTooltip = useCallback(() => {
    clearTimeout(hideTimer)
    setShow(true)
    hideTimer = self.setTimeout(() => setShow(false), timeout)
  }, [setShow, timeout])

  const hideTooltip = useCallback(() => {
    setShow(false)
  }, [setShow])

  return [
    showTooltip,
    hideTooltip,
    <Tooltip key="tooltip" show={show}>
      {text}
    </Tooltip>,
  ]
}

export default useTooltip
